import { useSynchronousBindingLazy } from './synchronous.binding';

export enum CacheWriteType {
  /**
   * Store data in a file-based cache.
   * Values are persisted between server reboots.
   */
  DISK = 'disk',
  /**
   * Store data in-memory.
   * More performant than the disk cache but
   * the values are not persisted between server reboots.
   */
  MEMORY = 'memory',
}

export interface CacheWriteBindingRequest {
  type?: CacheWriteType;

  path: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any;

  afterWriteDelay?: number;
}

export interface CacheWriterBindingContext {
  /**
   * Array of cache write requests
   */
  requests: CacheWriteBindingRequest[];

  /**
   * By default the binding provider will delete all cache keys
   * written when the binding is stopped. If this flag is set
   * to true then the keys will remain in the cache
   */
  persistCacheKeys?: boolean;

  onStop?: Omit<CacheWriterBindingContext, 'onStop'>;
}

export interface CacheWriterBindingResult {
  success: boolean;
}

const useCacheWriterBindingLazy = () => {
  const { send } = useSynchronousBindingLazy<
    CacheWriterBindingContext,
    CacheWriterBindingResult
  >({
    namespace: 'cache',
    type: 'writer',

    // optimize the cache writer by not closing the subscription immediately, but
    // instead let additional writes take place using the existing binding instance
    closeImmediately: false,
  });

  return send;
};

export { useCacheWriterBindingLazy };
